import { useEffect, useRef, useState } from 'react';
import { ProTableOt, Toaster, toast, Row, Col, Button, useProTableOt, Form, Modal, message, DatePicker, Select } from '../../ui/ot'
import { useBorrower } from '../controllers/BorrowerController';
import { useCheckoutHistory } from '../controllers/CheckoutHistoryController';
import dayjs from 'dayjs'
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HoldPriorityModal, { HoldPriorityForm } from './HoldPriorityModal';
import { useItem } from "../controllers/ItemController";
import { useHold } from "../controllers/HoldController";
import { useLibrary } from "../controllers/LibraryController";
import PageFrontendRowComponentSortModal from './HoldPrioritySortableModal';


const HoldPriorityProTableOt = ({
    keyPrefix = "library.backstage.Circulation.HoldPriority.items",
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    propsRowKey = "key",
    propsForm,
    customColumns = [],
    customFormItems = () => { },
    extraActionRender = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsUseCheckoutHistory = useCheckoutHistory,
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    onSelectChange = () => { },
    fieldName,
    hasValue = false,
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const actionRef = useRef()
    const [loading, setLoading] = useState(true);  // 加入 loading 狀態
    const [extra_columns, set_extra_columns] = useState([]);
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [form_] = Form.useForm();
    const form = propsForm ?? form_;
    const [axiosMode, setAxiosMode] = useState("get")
    const { borrowernumber } = useParams()
    const columns = [
        {
            title: t("collection_id"),
            dataIndex: 'item_itemnumber',
            key: 'item_itemnumber',
        },
        {
            title: t("collection_type"),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t("barcode"),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: t("collection_branch"),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t("current_location"),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: t("call_number"),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: t("copy_id"),
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        },
        {
            title: t("holds_number"),
            dataIndex: 'holds_number',
            key: 'holds_number',
            render: (text, record) => {
                console.log({HoldDatasssss: HoldData})
                let total_hold_length = 0
                HoldData.map((hold) => {
                    if(hold?.item_itemnumber === record?.item_itemnumber) {
                        total_hold_length = hold?.key
                    }
                })
                return <><Row><Col span={24}>{total_hold_length}</Col></Row></>
            }
        },
        ...customColumns,
    ];

    const setParamsFilter = (obj) => {
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            // postHoldData([values])
        }
        else if (axiosMode === "patch") {
            // patchHoldPriorityData([values])
        }
    }

    const onHoldFinish = ({ axiosMode, status, values }) => {
        propsOnFinish({ axiosMode, status, values })
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("預約成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reload();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("預約失敗")
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
            }
        }
    }
    const onHoldBefore = ({ axiosMode, status, values }) => {
        propsOnBefore({ axiosMode, status, values })
    }
    const onBefore = (value) => {
    }
    const onFinish = (value) => {
    }


    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        // if (fieldName) {
        //     if (propsForm) {
        //         formValues = propsForm.getFieldValue(fieldName)
        //     }
        //     else {
        //         formValues = form.getFieldValue(fieldName)
        //     }
        // } else {
        //     if (propsForm) {
        //         formValues = propsForm.getFieldsValue()
        //     }
        //     else {
        //         formValues = form.getFieldsValue()
        //     }
        // }
        // propsOnValuesChange({
        //     ...formValues,
        //     // ...e
        // })
    }

    const onHoldClick = (item) => {
        setAxiosMode("post")
        Modal.confirm({
            width: 500,
            title: t('hold_setting'),
            content: <>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                label={t('pickup_library')}
                                name={fieldName ? [fieldName, "pickup_library"].join('.') : "pickup_library"}
                                rules={!hasValue ? [ { required: true, message: "請輸入" } ] : []}
                            >
                                <Select
                                    style={{
                                        maxHeight: "80vh",
                                        minHeight: "20vh",
                                        overflowX: "scroll",
                                        overflowY: "scroll",
                                    }}
                                    options={LibraryData.map(item => (
                                        {
                                            label: item?.branchname,
                                            value: item?.branchcode,
                                        }
                                    ))}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={t('expiration_date')}
                                name={fieldName ? [fieldName, "expiration_date"].join('.') : "expiration_date"}
                                rules={!hasValue ? [ { required: true, message: "請輸入" } ] : []}
                            >
                                <DatePicker.Time />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </>,
            onOk: () => {
                const values = form.getFieldsValue()
                // onFormFinish({
                //     ...values,
                //     pickupLibrary: values?.pickup_library, 
                //     expiration_date: !!values?.expiration_date ? dayjs(values?.expiration_date).format("YYYY-MM-DD HH:mm:ss") : null, 
                //     itemnumber: item?.item_itemnumber,
                //     borrowernumber: borrowernumber
                // });
                postHoldData([
                    {
                        ...values,
                        pickupLibrary: values?.pickup_library, 
                        expiration_date: !!values?.expiration_date ? dayjs(values?.expiration_date).format("YYYY-MM-DD") : dayjs().add(1, 'month'), 
                        itemnumber: item?.item_itemnumber,
                        borrowernumber: borrowernumber
                    }
                ])
            },
            okText: t('ok'),
            cancelText: t('cancel'),
        })
    }
    const onHoldClickMultiple = () => {
        console.log({selectedRowsInfo})
    }

    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedRowsKeys)
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedRowsInfo)
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.[propsRowKey])
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.[propsRowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record?.[propsRowKey])
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record?.[propsRowKey])
                selectRow = selectRow.filter(row => row?.[propsRowKey] !== record?.[propsRowKey])
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const { check, setCheck, checkAll, setOrders, custom_filter_key } = useTableColumnsCheck(columns);

    
    const {
        LibraryData,
        getLibraryData
    } = useLibrary({
        onBefore: () => { },
        onLibrary: () => { },
    })
    const {
        ItemData,
        getItemData,
    } = useItem({})
    const {
        HoldData,
        getHoldData,
        postHoldData
    } = useHold({
        onFinish: ({ axiosMode, status, values }) => onHoldFinish({ axiosMode, status, values })
    })

    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        console.log({HoldData})
    }, [HoldData])
    useEffect(() => {
        getLibraryData()
        const fetchData = async () => {
            await getHoldData();
            setLoading(false); // 確保在資料取得後更新 loading 狀態
        };
        fetchData();
    }, [])


    // 檢查資料加載情況
    if (loading) {
        return <div>Loading...</div>; // 資料加載時顯示載入中
    }
    
    return <>
        <HoldPriorityModal
            axiosMode={axiosMode}
            propsOpen={modalOpen}
            propsSetOpen={setModalOpen}
            propsForm={form}
            propsLoading={modalLoading}
            propsSetLoading={setModalLoading}
            onFinish={onFormFinish}
            customFormItems={customFormItems}
        />
        <PageFrontendRowComponentSortModal
            // frontend_component_blog_type_data={frontend_component_blog_type_data || []}
            // setPageContainerData={setPageContainerData}
        />
        <ProTableOt
            actionRef={actionRef}
            columns={columns}
            check={check}
            setCheck={setCheck}
            headerTitle={<></>}
            rowKey={propsRowKey}
            request={async (params = {}, sort, filter) => {
                let newParams = {
                };
                let order = setOrders(sort)
                newParams = {
                    // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                    ...newParams,
                    order,
                    size: params.pageSize,
                    cur_page: params.current,
                    custom_filter_value: params.keyword ?? "",
                    custom_filter_key: custom_filter_key,
                };
                newParams = setParamsFilter({
                    ...newParams,
                });
                return getItemData({
                    ...newParams
                })
            }}
            extra_columns={extra_columns}
            set_extra_columns={set_extra_columns}
            manage_columns={true}
            rowSelection={{
                type: "checkbox",
                selectedRowKeys: selectedRowKeys,
                selectedRowsInfo: selectedRowsInfo,
                setSelectedRowKeys: setSelectedRowKeys,
                setSelectedRowsInfo: setSelectedRowsInfo,
                ...rowSelection,

            }}
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            scroll={{
                x: "100vw"
            }}
            toolBarRender={() => toolBarRender([
            ])}
            extraActionRender={(item) => {
                return (<>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Button variant="destructive" onClick={() => {
                                onHoldClick(item)
                            }}>{t("hold_priority")}</Button>
                        </Col>
                    </Row>
                </>)
            }}
            propsUseData={() => {
                return {
                    // postData: postCheckoutData,
                    // patchData: postCheckoutData,
                    // deleteData: deleteCheckoutHistoryData,
                }
            }}
            PropsPatchForm={
                <HoldPriorityForm
                    keyPrefix={keyPrefix}
                    customFormItems={customFormItems}
                />
            }
            propsPatchonFinish={({ axiosMode, status }) => {
                if (status === "success") {
                    actionRef.current.reload()
                } else {

                }
            }}
            propsPatchOnBefore={() => { }}
            propsPatch
            propsPost
            propsDelete
            propsPatchProcess={(item) => {
                return ({
                    ...item,
                    issue_date_due: dayjs(item?.issue_date_due),
                })
            }}
            propsWidth={1000}
        />
    </>
}

export default HoldPriorityProTableOt


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([]);
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    };
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: "DESC",
                });
            } else {
                return JSON.stringify({
                    column: key,
                    type: "ASC",
                });
            }
        });
        return newOrders;
    };
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders,
    };
};
